import { ProductButtonProps } from '../../pages/BatchTicket/components/DynamicButton';
import {
  DirectTreasuryOperationType,
  EquityOperationType,
} from '../../pages/NewApplication/Product/components/Equity/constants';
import { FixedIncomeOperationType } from '../../pages/NewApplication/Product/components/FixedIncome/constants';
import type { FundOperationType } from '../../pages/NewApplication/Product/components/Funds/constants';

import { closedFundMessage, zeroApplicationMinimumMessage } from './normalizer';
import { PrivatePensionDueDateOption } from './types';

export const FixedIncomeCategoryTabs = [
  { label: 'Todos', value: null },
  { label: 'CDB', value: 'CDB' },
  { label: 'LCA', value: 'LCA' },
  { label: 'LCI', value: 'LCI' },
  { label: 'CRA', value: 'CRA' },
  { label: 'CRI', value: 'CRI' },
  { label: 'LC', value: 'LC' },
  { label: 'LF', value: 'LF' },
  { label: 'DEB', value: 'DEB' },
] as const;

export const FundsCategoryTabs = [
  { label: 'Todos', value: null },
  { label: 'Ações', value: 'Stocks' },
  { label: 'Multimercado', value: 'MultiMarket' },
  { label: 'Renda fixa', value: 'FixedIncome' },
  { label: 'Cambial', value: 'ForeignExchangeRelated' },
  { label: 'Curto Prazo', value: 'ShortTerm' },
  { label: 'Referenciado', value: 'Referenced' },
  { label: 'Dívida Externa', value: 'ExternalDebt' },
] as const;

export const pagination = { limit: 40, page: 1 };

export const sortItemsFixedIncome = [{ sort: 'productDisplay', sortDirection: 'asc' }];
export const sortItemsDirectTreasury = [{ sort: 'titleName', sortDirection: 'asc' }];
export const sortItemsFund = [{ sort: 'productName', sortDirection: 'asc' }];

export const screenName = 'boleta-rapida';
export const screenNameCustomerApplication = 'customer-application';

export const defaultDebitDueDates: PrivatePensionDueDateOption[] = [1, 5, 10, 15, 20, 25].map(
  (day) => ({
    value: day.toString(),
    label: day.toString(),
  })
);

export const captionsIconMapping = {
  qualifiedInvestor: 'QualifiedClient',
  closedFund: 'Locked',
  professionalInvestor: 'ProfessionalInvestor',
  taxExempt: 'IncomeTaxExempt',
  dailyLiquidity: 'Liquidity',
  fgcProtected: 'Fgc',
  blocked: 'EyeOff',
};

export const equityOperationsTab = [
  {
    key: 'buy',
    label: 'COMPRA',
  },
  {
    key: 'sale',
    label: 'VENDA',
  },
];

export const fixedIncomeOperationsTab = [
  {
    key: 'apply',
    label: 'APLICAR',
  },
  {
    key: 'rescue',
    label: 'RESGATAR',
  },
];

export const directTreasuryOperationsTab = [
  {
    key: 'apply',
    label: 'APLICAR',
  },
  {
    key: 'rescue',
    label: 'RESGATAR',
  },
];

export const fundOperationsTab = [
  {
    key: 'apply',
    label: 'APLICAR',
  },
  {
    key: 'rescue',
    label: 'RESGATAR',
  },
];

export const fundComparisonPeriod = (months: number) => {
  switch (months) {
    case 12:
      return 'OneYear' as const;
    case 24:
      return 'TwoYears' as const;
    case 36:
      return 'ThreeYears' as const;
    default:
      return 'OneYear' as const;
  }
};

export const directTreasuryOperationTypeInitialTab = directTreasuryOperationsTab[0]
  .key as DirectTreasuryOperationType;
export const equityOperationTypeInitialTab = equityOperationsTab[0].key as EquityOperationType;
export const fixedIncomeOperationTypeInitialTab = fixedIncomeOperationsTab[0]
  .key as FixedIncomeOperationType;
export const fundOperationTypeInitialTab = fundOperationsTab[0].key as FundOperationType;

export const getFundsApplicationButtonState = (offer: ProductButtonProps<'funds'>['offer']) => {
  if (offer.closedFundNormalized) {
    return { isDisabled: true, tooltip: closedFundMessage };
  }
  if ((offer.orderValue ?? 0) <= 0) {
    return { isDisabled: true, tooltip: zeroApplicationMinimumMessage };
  }
  return { isDisabled: false, tooltip: undefined };
};
